import React, { useState, lazy } from 'react';
import { Plus, Check } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Product } from '../../data/mockProducts';
import { TrustBadge } from '../ui/TrustBadge';
import { useCart } from '../../hooks/useCart';
interface ProductCardProps {
  product: Product;
}
export function ProductCard({
  product
}: ProductCardProps) {
  const {
    addToCart
  } = useCart();
  const [isAdded, setIsAdded] = useState(false);
  const handleAdd = () => {
    addToCart(product);
    setIsAdded(true);
    setTimeout(() => setIsAdded(false), 1500);
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden flex flex-col h-full relative group" data-id="element-145">
      {/* Image Container */}
      <div className="aspect-square relative bg-gray-50 overflow-hidden" data-id="element-146">
        <img src={product.image} alt={product.altText} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" data-id="element-147" />

        {/* Badges Overlay */}
        <div className="absolute top-3 left-3 flex flex-col gap-2" data-id="element-148">
          {product.isWIC && <TrustBadge type="WIC" size="sm" data-id="element-149" />}
          {product.isEBT && <TrustBadge type="EBT" size="sm" data-id="element-150" />}
        </div>
      </div>

      {/* Content */}
      <div className="p-5 flex flex-col flex-grow" data-id="element-151">
        <div className="mb-2" data-id="element-152">
          <span className="text-xs text-gray-500 font-semibold uppercase tracking-wider" data-id="element-153">
            {product.category}
          </span>
        </div>

        <h3 className="font-bold text-gray-900 text-base leading-snug mb-3 line-clamp-2 min-h-[2.5rem]" data-id="element-154">
          {product.name}
        </h3>

        <div className="mt-auto pt-4 flex items-end justify-between gap-3" data-id="element-155">
          <div className="flex flex-col gap-1" data-id="element-156">
            <span className="text-xl font-bold text-[#2D5F3F]" data-id="element-157">
              ${product.price.toFixed(2)}
            </span>
            {product.isEBT && <span className="text-xs text-gray-500 font-medium" data-id="element-158">
                EBT Eligible
              </span>}
          </div>

          <motion.button whileTap={{
          scale: 0.9
        }} onClick={handleAdd} className={`h-12 w-12 rounded-full flex items-center justify-center shadow-lg transition-colors flex-shrink-0 ${isAdded ? 'bg-[#2D5F3F] text-white' : 'bg-[#D97757] text-white hover:bg-[#c66545]'}`} aria-label={`Add ${product.name} to cart`} data-id="element-159">
            <AnimatePresence mode="wait" data-id="element-160">
              {isAdded ? <motion.div key="check" initial={{
              scale: 0,
              rotate: -180
            }} animate={{
              scale: 1,
              rotate: 0
            }} exit={{
              scale: 0,
              rotate: 180
            }} data-id="element-161">
                  <Check className="w-6 h-6" data-id="element-162" />
                </motion.div> : <motion.div key="plus" initial={{
              scale: 0,
              rotate: 180
            }} animate={{
              scale: 1,
              rotate: 0
            }} exit={{
              scale: 0,
              rotate: -180
            }} data-id="element-163">
                  <Plus className="w-6 h-6" data-id="element-164" />
                </motion.div>}
            </AnimatePresence>
          </motion.button>
        </div>
      </div>
    </motion.div>;
}